// extracted by mini-css-extract-plugin
export default {"item":"PreBuiltItem_item__AXOIv","description":"PreBuiltItem_description__FDexV","price":"PreBuiltItem_price__ZuDqb"};